/**
 * UserApiClient -- HTTP client for /api/v1/Users.
 *
 * @module infrastructure/api/UserApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/Users';

export const UserApiClient = {
  async list(page = 1, pageSize = 50) {
    return ApiBase.get(`${BASE}?page=${page}&pageSize=${pageSize}`);
  },

  async getById(id) {
    return ApiBase.get(`${BASE}/${id}`);
  },

  async create(user) {
    return ApiBase.post(BASE, user);
  },

  async update(id, data) {
    return ApiBase.put(`${BASE}/${id}`, data);
  },

  async deactivate(id) {
    return ApiBase.del(`${BASE}/${id}`);
  }
};
